exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".MultipleChoiceExercise-module__wrapper___26G5h{display:flex;gap:3em;flex-wrap:wrap;justify-content:center;padding:1rem 0}", ""]);

// exports
exports.locals = {
	"wrapper": "MultipleChoiceExercise-module__wrapper___26G5h"
};